import { httpRequest } from "../../../utils/HttpRequest";
import {
    ISaleSoSearch,
    ISaleSoDetail,
    ISaleSoFields,
    ISaleSoList,
    Detailed,
    IInvalidate,
    ISaleSoPoSettleAndWhConfirm,
    ISaleSoSettleParams,
    ISaleSoStatistics
} from "./saleSoTypes"

class SaleSoService {
    async page(searchVo: ISaleSoSearch) {
        const apiUrl = "/zzw-vrm/sale/findPage";
        return await httpRequest.post<ISaleSoList>(apiUrl, searchVo);
    }
    async total(searchVo: ISaleSoSearch) {
        const apiUrl = "/zzw-vrm/sale/total";
        return await httpRequest.post<ISaleSoStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/sale/findById/${id}`;
        return await httpRequest.get<ISaleSoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleSoFields) {
        const apiUrl = "/zzw-vrm/sale/insert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleSoFields) {
        const apiUrl = "/zzw-vrm/sale/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/sale/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: ISaleSoFields) {
        const apiUrl = "/zzw-vrm/sale/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //转销售单
    async transfer(planCode: string) {
        const apiUrl = `/zzw-vrm/sale/transfer/${planCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // //详情导入
    // async invalidate(){
    //     const apiUrl = "/zzw-vrm/sale/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/zzw-vrm/sale/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //作废
    async invalidate(params: IInvalidate) {
        const apiUrl = "/zzw-vrm/sale/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //库房确认
    async warehousing(params: ISaleSoPoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/sale/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售结算
    async settle(params: ISaleSoSettleParams) {
        const apiUrl = "/zzw-vrm/sale/settlePro";
        // const apiUrl = "/zzw-vrm/sale/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售补单
    async supplementInsert(insertVo: ISaleSoFields) {
        const apiUrl = "/zzw-vrm/sale/supplementInsert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    //详情导出
    async detailsExport(params: ISaleSoFields) {
        const apiUrl = "/zzw-vrm/sale/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/sale/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
    async someSettle(params: any) {
        const apiUrl = `/zzw-vrm/sale/warehousingBatch`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}

export const saleSoService = new SaleSoService();